import React, { useCallback, useContext, useEffect, useState,  } from 'react';
import { Autocomplete, FormControl, InputLabel, TextField, Box } from '@mui/material';
import { AppContext } from 'core/context/';
import { getVendorList } from 'services/vendors';
import { useSnackbar } from 'notistack';

const VendorSelect = ({onVendorSelected, variant="standard", width=280, defaultSelectId=null}) => {
  const [vendorList, setVendorList] = useState([]);
  const [vendorSelected, setVendorSelected] = useState('');
  const { vendors=[], updateAppContext } = useContext(AppContext);
  const { enqueueSnackbar } = useSnackbar();

  const getVendors = useCallback(
    () => {
      getVendorList().then(({response, error}) => {
        if(response){
          updateAppContext({vendors: response});
        } else {
          enqueueSnackbar((response?.message || error), {variant: 'error'});
        }
      });
    },
  [enqueueSnackbar, updateAppContext],)

  useEffect(() => {
    if(vendors?.length){
      setVendorList(vendors);
      if(defaultSelectId){
        const foundVendor = vendors.filter(vendor=> vendor?.userId===defaultSelectId);
        if(foundVendor?.length > 0) {
          setVendorSelected(foundVendor[0]);
          return;
        }
      }
      // setVendorSelected(vendors[0]);
    }else if(vendors === null){
      getVendors();
    }
  }, [vendors, defaultSelectId, getVendors]);

  useEffect(() => {
    if(typeof onVendorSelected === 'function'){
      onVendorSelected(vendorSelected);
    }
  }, [vendorSelected, onVendorSelected]);

  const filterOptions = useCallback((options, { inputValue }) => {
    if(inputValue){
      return options.filter((option) => option?.displayName?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) || option?.mobile?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()));
    }
    return options;
  }, []);

  return (
    <FormControl sx={{fontSize: 12}} fullWidth>
      {variant !== 'standard' ? <InputLabel id="library-select-label">Library</InputLabel>:null}
      <Autocomplete
        options={vendorList}
        size="small"
        name="userId"
        id="userId"
        fullWidth
        defaultValue={[]}
        value={vendorSelected}
        filterOptions={filterOptions} 
        getOptionLabel={(option) => option?.displayName || option }
        isOptionEqualToValue={(option, value) => (option?.userId === value?.userId)}
        onChange={(event, newValue) => {
          setVendorSelected(newValue);
        }}
        // key={option => option.userId}
        renderOption={(props, option) => <li {...props} key={option.userId}>
          <Box>
            {option.displayName}
            <small style={{display:'block', color: '#637381'}}>{option.mobile}</small>
          </Box>
          </li>}
        renderInput={(params) => (
          <TextField 
            {...params} 
            fullWidth
            label="Vendor"
            InputProps={{
              ...params.InputProps,
              // startAdornment: 
              //   <InputAdornment position="start" >
              //     <IconButton
              //       aria-label="Library Name"
              //       edge="end"
              //     >
              //       <PersonIcon />
              //     </IconButton>
              //   </InputAdornment>
            }}
          />
        )}
      />
    </FormControl>
  );
}
 
export default React.memo(VendorSelect);
